import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';

import ActivityForm from './ActivityForm';
import LoadingPageText from '../../common/Loading/LoadingPageText';

import { useFetchActivities } from '../../../actions/areas/admin/fetchHooks/fetchActivity';
import { tableSettings } from './activityTableSettings';
import { eventHandlers } from './activityHandler';
import _ from './../../../utils/lodash';

export default function ActivityContent({ visitType, status }) {
  const [state, setState] = useState({
    forceReload: false,
    currentPage: 1,
    pageSize: 15,
    openSideActivityTypePanel: false,
    sortColumn: 'Name',
    sortDirection: 'asc',
    activityWithDefaultValues: {},
    errorMsg: null,
    isDataLoading: false,
  });

  const model = {
    careType: visitType,
    isActive: status,
    pageSize: state.pageSize,
    currentPage: state.currentPage,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
  };
  const { data, isDataLoading, auth, isTableDataLoading } = useFetchActivities(model, state.forceReload);

  const settingList = useSelector(store => store.global.auth.settings);
  const enableMappingOfActivitiesSetting = _.find(settingList, 'EnableMappingOfActivities');
  const enableMappingOfActivities = _.values(enableMappingOfActivitiesSetting)[0];

  const events = eventHandlers(state, setState, auth);
  const settings = tableSettings({
    visitType,
    count: data.totalCount,
    page: data.currentPage - 1,
    pageSize: data.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    eventHandlers: events,
    isTableDataLoading,
    enableMappingOfActivities,
  });

  if (isDataLoading)
    return <LoadingPageText showHeader={false}>Wait a moment while we gather Activity list info...</LoadingPageText>;

  const props = {
    visitType,
    events,
    activity: state.activityWithDefaultValues,
    errorMsg: state.errorMsg,
    isDataLoading: state.isDataLoading,
    enableMappingOfActivities,
  };

  return (
    <div className="page-content-wrapper">
      <MUIDataTable
        title={settings.name}
        data={data.mappedActivities}
        columns={settings.columns}
        options={settings.options}
      />
      {state.openSideActivityTypePanel && <ActivityForm props={props} />}
    </div>
  );
}
